/**
 * @desc 切换会员
 */
import { SwitchProfile } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type SwitchMemberParameter = SwitchProfile

const method = 'PUT'
const url = '/auth/switch'

export const switchMemberApi = (
  data?: SwitchMemberParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

switchMemberApi.method = method
switchMemberApi.url = url
